import { QueryStatus } from 'react-query';

export enum ShowCashAccountType {
  All = 'All',
  Self = 'Self',
}

export type Member<Fevent = string, Bugo = undefined, CashAccount = string> = {
  _id: string;
  fevent: Fevent;
  bugo?: Bugo;
  cashAccount: CashAccount;
  subCashAccounts?: CashAccount[];
  fullName: string; // 부고장 공유시 보이는 전체이름
  shortName: string; // 부고장 명단에 보이는 짧은이름
  shareDisplayCustom?: {
    topString?: string;
    bottomString?: string;
  }; // 부고장 공유시 보이는 이름(여러명 묶을 수도 있음) OOO,OOO 부친상
  relationType: string; // (고인에게 이 멤버의 친척 용어) 자, 녀
  reverseType: string; // (이 멤버에게 고인의 친척 용어) 모친, 부친
  phoneNumber: string;
  cashAccountFixed?: boolean;
  cashAccountModalConfirmed: boolean;
  privacyAgreement: boolean;
  createdAt: Date;
  updatedAt: Date;
  showCashAccountType?: ShowCashAccountType;
};

export type MemberState<Fevent = string, Bugo = undefined, CashAccount = string> = {
  status: QueryStatus;
  data: Member<Fevent, Bugo, CashAccount> | null;
};

export type MemberCreate = Omit<
  Member<string, undefined, string | undefined>,
  '_id' | 'createdAt' | 'updatedAt'
>;

export type MemberUpdate<Fevent = string, Bugo = undefined, CashAccount = string> = {
  _id: string;
  fevent?: Fevent;
  bugo?: Bugo;
  cashAccount?: CashAccount | null;
  subCashAccounts?: string[];
  fullName?: string; // 부고장 공유시 보이는 전체이름
  shortName?: string; // 부고장 명단에 보이는 짧은이름
  shareDisplayCustom?: {
    topString?: string;
    bottomString?: string;
  };
  relationType?: string; // (고인에게 이 멤버의 친척 용어) 자, 녀
  reverseType?: string; // (이 멤버에게 고인의 친척 용어) 모친, 부친
  phoneNumber?: string;
  cashAccountModalConfirmed?: boolean;
  privacyAgreement?: boolean;
  showCashAccountType?: ShowCashAccountType;
};
